import { render, staticRenderFns } from "./FundingAssessmentsReviewTable.vue?vue&type=template&id=5f7ec658&"
import script from "./FundingAssessmentsReviewTable.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports